<template>
    <div>
        <banet-modal-confirm
            @confirmNo="confirm(false)"
            @confirmYes="confirm(true)"
            :show="showConfirm"
            :showFooter="true"
            :title="getTranslation('modal_confirm_title')"
            :body="getTranslation('label_confirm_customer_delete')">
        </banet-modal-confirm>
        <h2 v-if="!hideTitle">{{ getTranslation('lbl_customerlist_headline') }}</h2>
        <div class="well">
            <div class="row">
                <div class="col-md-2 col-sm-4">
                    <form id="search" style="position: relative; z-index: 0;">
                        <div class="input-group">
                            <span class="input-group-addon glyphicon glyphicon-search" aria-hidden="true"
                                  :title="getTranslation('lbl_search')"></span>
                            <input name="query" v-model="searchQuery"
                                   class="form-control" :placeholder="getTranslation('lbl_search')">
                            <span class="input-group-addon">
                                <button class="btn btn-default" @click.prevent="searchQuery = ''">
                                    <span class="glyphicon glyphicon-remove"></span>
                                </button>
                            </span>
                        </div>
                    </form>
                </div>
                <div class="col-md-10 col-sm-8 same-row-spaced-apart-aligned-right">
                    <div style="display: flex; margin-right: 1rem;">
                      <label style="margin: 0 1rem 0 0 !important;">{{ getTranslation('lbl_activate_code') }}</label>
                      <app-switch
                          :autoSave="true"
                          @switchedActivateCode="updateClient"
                          :isInList="false"
                          identification="codeActive"
                          v-model="client.codeActive"
                      />
                    </div>
                    <router-link :to="`/addcustomer/${isClientSubPage ? client._id : '' }`" activeClass="active"
                                 tag="button" class="btn btn-default pull-right">
                        {{ getTranslation('app_lbl_action_customer_create') }}</router-link>
                </div>
            </div>
        </div>
        <app-customer-table
            :data="fullGridData"
            :filter-key="searchQuery"
            @delete="customerDelete"
            @update="customerUpdate"
            actionCol
            cancelBtn
            deleteBtn
            editBtn
        />
    </div>
</template>

<script>
    import { mainEventBus } from '../../../../main';
    import {customerMixin} from '../../../../Banet/mixins/customerMixin.js';
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import {alertMixin} from '../../../../Banet/mixins/alertMixin.js';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    import Switch from '../../../public/components/Switch.vue';
    import CustomerTable from "./CustomerTable.vue";

    export default {
        props: ['client', 'hideTitle', 'isClientSubPage'],
        mixins: [ customerMixin, translationMixin, alertMixin ],
        sockets: {
            customerChanged: function(){
                this.getCustomers();
            }
        },
        components: {
            banetModalConfirm: BanetModalConfirm,
            appSwitch: Switch,
            appCustomerTable: CustomerTable
        },
        data: function() {
            return {
                searchQuery: '',
                gridColumns: [],
                gridData: [],
                selectedCustomer: {},
                appUser: false,
                clientUser: false,
                codeActive: false
            }
        },
        created: function() { this.calculateClient(); },
        mounted() {
            mainEventBus.$on('switchedActivity', (itemval) => this.customerUpdate(itemval));
        },
        computed: {
            fullGridData: function(){
               let gridData = [];
               if( this.loggedRole === 'client'){
                  gridData = this.gridData;
               } else if(this.appUser && this.clientUser){
                  mainEventBus['clientUser'] = true;
                  mainEventBus['appUser'] = true;
                  gridData = this.gridData;
               } else if(this.appUser && !this.clientUser){
                    mainEventBus['clientUser'] = false;
                    mainEventBus['appUser'] = true;
                    const store = this.$store;
                    gridData = this.gridData.filter(function(row){
                        return (row.role && row.role !== 'client-admin' && row.email !== store.state.user.email) ? row : false;
                    });
               } else if(this.clientUser && !this.appUser){
                    mainEventBus['clientUser'] = true;
                    mainEventBus['appUser'] = false;
                    gridData = this.gridData;
               } else if (!this.appUser && !this.clientUser) {
                  gridData = [];
               }
               return gridData;
            }
        },
        watch: {
            translations: function() {
                this.gridColumns = [
                    { label: this.getTranslation('lbl_customer_name'), value: 'name' },
                    { label: this.getTranslation('lbl_customer_code'), value: 'code' },
                    { label: this.getTranslation('lbl_customer_active'), value: 'active' },
                ];
                if(this.loggedRole === 'client' || this.loggedRole === 'user') {
                   this.gridColumns.splice(-1, 1);
                }
            }
        },
        methods: {
            calculateClient() {
                if(this.client) {
                    this.clientUser = true;
                    this.appUser = false;
                } else {
                    this.clientUser = false;
                    if( this.isAdmin){
                        this.appUser = true;
                    }
                }
                this.getCustomers();
            },
            getCustomers: function(){
                const url = (this.isClientSubPage) ? `customer/${this.client._id}/list` : 'customer';
                this.$http.get(url).then(res => {
                    this.gridData = res.data.obj;
                }, res => {
                    // error callback
                    console.log('Cannot get Customers');
                });
            },
            customerDelete: function(customer){
                this.selectedCustomer = customer;
                this.showConfirm = true;
            },
            customerUpdate: function (customer) {
              this.selectedCustomer = customer;
              this.$socket.emit('customerUpdate', this.selectedCustomer);
              this.selectedCustomer = {};
            },
            updateClient() {
              this.$socket.emit('activateCustomers', this.client);
            },
            confirm: function(y){
                this.showConfirm = false;
                if(y){
                    this.deleteConfirmed = true;
                    this.$socket.emit('customerDelete', this.selectedCustomer);
                    this.selectedCustomer = {};
                } else {
                    this.deleteConfirmed = false;
                    this.selectedCustomer = {};
                    return false;
                }
            },
            setFilterAppUser(event){

           },
            setFilterClientUser(clientUser){

           },
        }
    }
</script>

<style scoped>
  .same-row-spaced-apart-aligned-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// CustomerList.vue?51ab4e5c